import * as angular from 'angular';

import { IUploadService } from '../helpers';
import { BulkInsertResult } from '../../models/DTO/BulkInsertResult';
import { IRequestService } from '../../services';

export interface IBulkInsertService {
    bulkInsert(file: File): angular.IPromise<BulkInsertResult>;
}

export class BulkInsertService implements IBulkInsertService {
    static serviceId = 'bulkInsertService';

    static $inject = [
        'uploadService',
        'requestService'
    ];

    constructor(
        private _uploadService: IUploadService,
        private _requestService: IRequestService
    ) {
    }

    private controllerUrl(): string {
        return this._requestService.getUrlV1() + 'bulkInsert';
    }

    bulkInsert(file: File): angular.IPromise<BulkInsertResult> {
        return this._uploadService.uploadFile<BulkInsertResult>(this.controllerUrl(), file);
    }
}